import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["checkbox", "eventCategories"];

  connect() {
    this.toggle();
  }

  toggle() {
    if (!this.hasEventCategoriesTarget) return;

    this.eventCategoriesTarget.style.display = this.protectionEnabled()
      ? "block"
      : "none";
  }

  protectionEnabled() {
    if (!this.hasCheckboxTarget) return false;

    const input = this.checkboxTarget;
    if (input.type === "checkbox") return input.checked;

    return ["true", "1", "on"].includes(String(input.value).toLowerCase());
  }
}
